import angular from 'angular';

export default angular
	.module('ui.cian.utils.parseShareAmount', [])
	.directive('cianUtilsParseShareAmount', () => {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: (scope, element, attrs, ngModel) => {
				const rules = [{ // persent 25%
					parse: matches => {
						let val = matches[1].replace(',', '.');
						val = parseFloat(val) / 100;
						return val;
					},
					regexp: new RegExp(/^(\d+?([\.,]\d+?)?)\%$/)
				}, { // fraction 1/4
					parse: matches => {
						const numerator = parseInt(matches[1], 10);
						const denominator = parseInt(matches[2], 10);
						const val = numerator / denominator;
						return val;
					},
					regexp: new RegExp(/^(\d+?)\/(\d+?)$/)
				}, { // float 0.25
					parse: matches => {
						let val = matches[1].replace(',', '.');
						val = parseFloat(val);
						return val;
					},
					regexp: new RegExp(/^(0[\.,]\d+?)$/)
				}];

				const validateView = (modelValue, viewValue) => {
					let isValid = false;
					if (viewValue) {
						isValid = rules.some(rule => {
							return rule.regexp.test(viewValue);
						});
					}

					return isValid;
				};

				const parseInput = input => {
					input = String(input);
					for (const rule of rules) {
						const matches = input.match(rule.regexp);
						if (matches) {
							return rule.parse(matches); // TODO toFixed?
						}
					}

					return input;
				};

				const validateMax = input => {
					let isValid = true;
					const inputNumber = parseInput(input);
					if (!isNaN(inputNumber) && !ngModel.$error.parse && inputNumber >= 1) {
						isValid = false;
					}
					return isValid;
				};

				const validateMin = input => {
					let isValid = true;
					const inputNumber = parseInput(input);
					if (!isNaN(inputNumber) && !ngModel.$error.parse && inputNumber <= 0) {
						isValid = false;
					}
					return isValid;
				};

				ngModel.$validators.parse = validateView;
				ngModel.$validators.max = validateMax;
				ngModel.$validators.min = validateMin;

				element.on('blur', () => {
					if (ngModel.$valid && angular.isString(ngModel.$modelValue)) {
						const newVal = ngModel.$modelValue.replace(',', '.');
						if (newVal !== ngModel.$modelValue) {
							ngModel.$setViewValue(newVal);
							element.val(newVal);
						}
					}
				});
			}
		};
	})
	.name;
